import { transactionTypes as constantsTransactionTypes } from '@/returns/constants'

export const transactionTypes = [
  {
    value: constantsTransactionTypes.refund,
    label: 'Devoluciones',
  },
  {
    value: constantsTransactionTypes.exchange,
    label: 'Cambios',
  },
]
